export const RoutePaths = {
  LOGIN: '/login',
  CREATE_PLAN: '/create-plan',
  EDIT_PLAN: '/edit-plan',
  NEW_ORGANIZATION: '/organization/new',
  USER_PROFILE: '/profile',
  EMBEDDED_AUTH: '/embedded-auth',
  EMBEDDED_MAP: '/embedded-map',
  WELCOME: '/welcome',
  CHANGE_REQUESTS: '/change-requests'
};

export const RootPaths = [RoutePaths.EMBEDDED_MAP];

export const ExternalRoutePaths = {
  PRIVACY_STATEMENT: 'https://www.varicent.com/privacy-policy',
  TERMS_OF_SERVICE: 'https://www.varicent.com/terms-and-conditions'
};

export type DocsLinkEntry = {
  internal: string;
  external: string;
};
export const DOCS_LINKS = {
  MAPS_GEOGRAPHY_LEVEL: {
    internal: 'en/command-center/hierarchies/standard-geographies-hierarchy-data.html',
    external:
      's/document-item?bundleId=sales-planning-guide&topicId=getting-started/importing-data-files-into-tqp/hierarchy-files/standard-geographies-hierarchy-data/adding-standard-geographies-hierarchy-data.html&_LANG=enus'
  },
  CUSTOMER_ACCOUNT_HIERARCHY_UPLOAD: {
    internal: 'en/command-center/hierarchies/importing-hierarchy-files-to-the-customer-accounts-hierarchy.html',
    external:
      's/document-item?bundleId=sales-planning-guide&topicId=getting-started/importing-data-files-into-tqp/hierarchy-files/importing-hierarchy-files-to-built-in-hierarchies.html&_LANG=enus'
  }
} as const satisfies Record<string, DocsLinkEntry>;
export type DocsLinkKey = keyof typeof DOCS_LINKS;
